import { ChakraAvatar } from '@web/components/atoms/Avatar'
import { Box, Circle, Float } from '@web/components/atoms/Layout'
import { Body2 } from '@web/components/atoms/Typography'
import { getInitials } from '@web/components/chakra-ui/avatar'
import { pickPalette } from '../utils'
import { useColorWithOpacity } from '@web/components/molecules/ColorPicker/utils'
import { DEFAULT_LEADERBOARD } from '../default'

type LeaderboardAvatarProps = {
  name: string
  avatarUrl?: string
  index: number
  styles?: Record<string, string>
}

const RANKING_COLORS = ['#CFB624', '#C0C0C0', '#CD7F32']

const LeaderboardAvatar = ({ name, avatarUrl, index, styles }: LeaderboardAvatarProps) => {
  const medalColor = styles?.hasMedalColors ? RANKING_COLORS[index] : undefined
  const rankingColor = useColorWithOpacity(
    styles?.rankingColor ?? '',
    '1',
    DEFAULT_LEADERBOARD.styles?.profile?.rankingColor,
  )
  const rankingTextColor = useColorWithOpacity(
    styles?.rankingTextColor ?? '',
    '1',
    DEFAULT_LEADERBOARD.styles?.profile?.rankingTextColor,
  )
  return (
    <Box w="98px" h="98px">
      <ChakraAvatar.Root size="full" colorPalette={pickPalette(name)} css="c-leaderboard-profile__image">
        <ChakraAvatar.Fallback>{getInitials(name)}</ChakraAvatar.Fallback>
        <ChakraAvatar.Image src={avatarUrl || undefined} />
        {styles?.hasRanking && (
          <Float placement="top-start" offsetX="2" offsetY="2">
            <Circle bg={medalColor ?? rankingColor} size="24px">
              <Body2 color={medalColor ? '#FFFFFF' : rankingTextColor}>{index + 1}</Body2>
            </Circle>
          </Float>
        )}
      </ChakraAvatar.Root>
    </Box>
  )
}

export default LeaderboardAvatar
